import React from 'react'
import styled from 'styled-components'

import { FULL_SCREEN_LOADER_TEXT } from '../resources/labels.json'

const StyledSpinner = styled.svg`
  margin-bottom: 20px;
  animation: rotate 1s linear infinite;
  width: 70px;
  height: 70px;

  & .path {
    stroke: #118785;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`
const SpinnerWrapper = styled.div`
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export default function FullScreenLoader(props) {
  const { title } = props
  return (
    <SpinnerWrapper>
      <StyledSpinner viewBox="0 0 50 50">
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="2"
        />
      </StyledSpinner>

      {title && <h2 className="text-center">{FULL_SCREEN_LOADER_TEXT}</h2>}
    </SpinnerWrapper>
  )
}
